import { Box, Button, Grid, useMediaQuery } from "@mui/material";
import React, { useEffect, useState } from "react";
import "./Main.css";
import Logo from "../../assets/logo_quick-learning-tool.png";
import BG from "../../assets/qlt6_intro-background.png";
import Chat from "../components/Chat";
import InstructionsEng from "../components/instructionsEng";
import InstructionsFil from "../components/instructionsFil";
import { getRightsVar, getRightsVarFIL } from "../../utils/firestoreQuery";
import Play from "../../assets/play.png";
import FinishBG from "../../assets/flowing-cape.gif";
import { Check, Replay } from "@mui/icons-material";
import { useSelector } from "react-redux";

function Main() {
  const md = useMediaQuery("(min-width:900px)", { noSsr: true });
  const xs = useMediaQuery("(max-width:600px)", { noSsr: true });
  const [objData, setObjData] = useState();
  const [start, setStart] = useState(false);
  const [finish, setFinish] = useState(false);
  const [part, setPart] = useState(0);
  const [language, setLanguage] = useState("ENG");
  const percent = useSelector((state) => state.chat.percent);

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (language === "ENG") {
          const documentSnapshot = await getRightsVar().get();
          if (documentSnapshot.exists) {
            const data = documentSnapshot.data();
            setObjData(data);
          } else {
            console.log("Document does not exist");
          }
        } else if (language === "FIL") {
          const documentSnapshot = await getRightsVarFIL().get();
          if (documentSnapshot.exists) {
            const data = documentSnapshot.data();
            setObjData(data);
          } else {
            console.log("Document does not exist");
          }
        }
      } catch (error) {
        console.error("Error fetching document:", error);
      }
    };

    fetchData();
  }, [language]);

  const handleRestart = () => {
    setFinish(false);
    setStart(false);
    setPart(0);
  };

  const handleNextPart = () => {
    setPart(part + 1);
  };

  const handleLink = () => {
    window.location.href = "https://www.aralplus.ph/quick-learning-tools";
  };

  const handleStart = (lang) => {
    setLanguage(lang);
    setTimeout(() => {
      setStart(true);
    }, 1000);
  };

  return (
    <Box>
      <Grid container>
        <Grid item xs={12} lg={3.95}>
          <Box className="left-card">
            <Box className="left-container">
              <Grid container justifyContent="center" alignItems="center">
                <Grid item xs={12}>
                  <Box className="img-container">
                    <img src={Logo} alt="logo" className="image" />
                  </Box>
                </Grid>
                <Grid item xs={12}>
                  {language === "ENG" ? (
                    <InstructionsEng />
                  ) : (
                    <InstructionsFil />
                  )}
                </Grid>
                <Grid item xs={12}>
                  <Box className="button-container">
                    {finish ? (
                      <>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <Button
                            className="button-left"
                            onClick={handleRestart}
                          >
                            <Replay
                              sx={{
                                marginRight: ".3rem",
                                fontWeight: "900",
                                fontSize: "1.6rem",
                              }}
                            />
                            Restart
                          </Button>
                          <Box
                            sx={{
                              marginTop: "1rem",
                              color: "#0ebeef",
                              fontSize: "1.15rem",
                              fontWeight: "700",
                              cursor: "pointer",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                            onClick={() => handleLink()}
                          >
                            Back to Quick Learning Tools
                          </Box>
                        </Box>
                      </>
                    ) : (
                      <>
                        {start ? (
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            {percent >= 100 && part === 3 ? (
                              <>
                                <Button
                                  className="button-left"
                                  onClick={() => setFinish(true)}
                                >
                                  <Check
                                    sx={{
                                      marginRight: ".5rem",
                                    }}
                                  />
                                  Finish
                                </Button>
                              </>
                            ) : (
                              <>
                                <Button
                                  className="button-left-disabled"
                                  onClick={() => setFinish(true)}
                                  disabled={true}
                                >
                                  <Check
                                    sx={{
                                      marginRight: ".5rem",
                                    }}
                                  />
                                  Finish
                                </Button>
                              </>
                            )}
                          </Box>
                        ) : (
                          <>
                            <Box
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <Button
                                className="button-left"
                                onClick={() => handleStart("ENG")}
                              >
                                <img
                                  src={Play}
                                  alt="Start"
                                  style={{
                                    marginRight: "10px",
                                    objectFit: "contain",
                                    width: "15px",
                                  }}
                                />
                                Start (English)
                              </Button>
                              <Button
                                className="button-left"
                                onClick={() => handleStart("FIL")}
                                sx={{ marginBottom: "1rem" }}
                              >
                                <img
                                  src={Play}
                                  alt="Start"
                                  style={{
                                    marginRight: "10px",
                                    objectFit: "contain",
                                    width: "15px",
                                  }}
                                />
                                Start (Filipino)
                              </Button>
                            </Box>
                          </>
                        )}
                      </>
                    )}
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Box>
        </Grid>
        <Grid item xs={12} lg>
          {finish ? (
            <Box
              className="right-card"
              //   sx={{ backgroundImage: `url(${FinishBG})` }}
            >
              <div
                style={{
                  position: "relative",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                }}
              >
                <img
                  src={FinishBG}
                  style={{
                    display: "block",
                    width: "100%",
                    height: md ? "100vh" : "auto",
                    objectFit: "fill",
                  }}
                  alt="image"
                />
                <Box
                  sx={{
                    position: "absolute",
                    top: md ? "0%" : "15%",
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: md ? "center" : "left",
                    flexDirection: "column",
                    // paddingTop: md ? "0" : "5%",
                    paddingLeft: "1rem",
                  }}
                >
                  <div
                    style={{
                      color: "white",
                      fontSize: md ? "3rem" : "1.5rem",
                    }}
                  >
                    {" "}
                    <b>Congrats!</b>
                  </div>
                  <div
                    style={{ color: "white", fontSize: md ? "2rem" : "1rem" }}
                  >
                    {"en" === "en"
                      ? "You just finished this learning tool."
                      : "Natapos mo na ang learning tool na ito."}
                  </div>
                </Box>
                <div
                  style={{
                    position: md ? "absolute" : "inherit",
                    width: "100%",
                    height: "100%",
                    paddingTop: "1rem",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      backgroundColor: "#FFFFFF40",
                      height: "60%",
                      padding: "1.5rem",
                      borderRadius: "1rem",
                      width: md ? "60%" : "90%",
                      marginTop: md ? "14%" : "",
                      marginLeft: md ? "2%" : "5%",
                      marginBottom: md ? "2%" : "5%",
                    }}
                  >
                    {objData && (
                      <Chat
                        pageLang={language}
                        objData={objData?.zClosing}
                        mainContainer={{
                          height: md ? "inherit" : "400px",
                          flexGrow: "1",
                        }}
                      />
                    )}
                  </Box>
                </div>
              </div>
            </Box>
          ) : (
            <Box
              className="right-card"
              sx={
                {
                  //backgroundImage: `url(${BG})`
                }
              }
            >
              <div
                style={{
                  position: "relative",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                  paddingBottom: md ? "0rem" : "1rem",
                }}
              >
                <img
                  src={BG}
                  style={{
                    display: "block",
                    width: "100%",
                    height: md ? "100vh" : "auto",
                    objectFit: "fill",
                  }}
                  alt="image"
                />

                {/* <Grid container rowSpacing={2}>
                <Grid item xs={12}> */}

                <div
                  style={{
                    position: xs ? "inherit" : "absolute",
                    width: "100%",
                    height: "100%",
                    paddingTop: "1rem",
                  }}
                >
                  {start && (
                    <>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          backgroundColor: "#FFFFFF40",
                          height: "60%",
                          padding: "1.5rem",
                          borderRadius: "1rem",
                          width: "70%",
                          marginLeft: "15%",
                        }}
                      >
                        {/* <Box className="convo-container"> */}
                        {objData && (
                          <>
                            {part === 0 && (
                              <Chat
                                pageLang={language}
                                objData={objData?.intro}
                                mainContainer={{
                                  height: md ? "inherit" : "400px",
                                  flexGrow: "1",
                                }}
                              />
                            )}
                            {part === 1 && (
                              <Chat
                                pageLang={language}
                                objData={objData?.step1}
                                mainContainer={{
                                  height: md ? "inherit" : "400px",
                                  flexGrow: "1",
                                }}
                              />
                            )}
                            {part === 2 && (
                              <Chat
                                pageLang={language}
                                objData={objData?.step2}
                                mainContainer={{
                                  height: md ? "inherit" : "400px",
                                  flexGrow: "1",
                                }}
                              />
                            )}
                            {part === 3 && (
                              <Chat
                                pageLang={language}
                                objData={objData?.step3}
                                mainContainer={{
                                  height: md ? "inherit" : "400px",
                                  flexGrow: "1",
                                }}
                              />
                            )}
                          </>
                        )}
                      </Box>
                      {/* </Box> */}
                      {percent >= 100 && part < 3 && (
                        <Box className="button-container">
                          <Button
                            className="proceed-button"
                            onClick={handleNextPart}
                          >
                            {language === "ENG" ? "Next Part" : "Sumunod"}
                          </Button>
                        </Box>
                      )}
                    </>
                  )}
                </div>
              </div>
              {/* </Grid>
              </Grid> */}
            </Box>
          )}
        </Grid>
      </Grid>
    </Box>
  );
}

export default Main;
